var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.5592 1.58929L18.6039 7.4L25.5592 13.2107C25.7678 13.385 25.7678 13.6949 25.5592 13.8693C25.3505 14.0436 24.9796 14.0436 24.7709 13.8693L17.4447 7.72927C17.3287 7.63243 17.2824 7.51621 17.2824 7.4C17.2824 7.28379 17.3287 7.16757 17.4447 7.07073L24.7941 0.930742C25.0028 0.756421 25.3737 0.756421 25.5824 0.930742C25.791 1.10506 25.791 1.41497 25.5592 1.58929Z",
    fill: "#EEE9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.1056 1.58929L10.1503 7.4L17.1056 13.2107C17.3142 13.385 17.3142 13.6949 17.1056 13.8693C16.8969 14.0436 16.526 14.0436 16.3173 13.8693L8.99106 7.72927C8.87513 7.63243 8.82877 7.51621 8.82877 7.4C8.82877 7.28379 8.87513 7.16757 8.99106 7.07073L16.3405 0.930742C16.5492 0.756421 16.9201 0.756421 17.1288 0.930742C17.3374 1.10506 17.3374 1.41497 17.1056 1.58929Z",
    fill: "#EEE9FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.65172 1.58929L1.69642 7.4L8.65172 13.2107C8.86038 13.385 8.86038 13.6949 8.65172 13.8693C8.44306 14.0436 8.07211 14.0436 7.86345 13.8693L0.537199 7.72927C0.421277 7.63243 0.374909 7.51621 0.374909 7.4C0.374909 7.28379 0.421277 7.16757 0.537199 7.07073L7.88664 0.930742C8.09529 0.756421 8.46624 0.756421 8.6749 0.930742C8.88356 1.10506 8.88356 1.41497 8.65172 1.58929Z",
    fill: "#EEE9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThLeftArrow);
export default __webpack_public_path__ + "static/media/th-left-arrow.9770606ccec555a70be579258ec3a401.svg";
export { ForwardRef as ReactComponent };